import { Alert, Button, Card, Center, Group, Stack, Text, Title } from "@mantine/core";
import { beginOAuthLogin } from "../api.ts";
import { setCachedMe } from "./OAuthGuard.tsx";

export function OAuthLoggedOut() {
  return (
    <Center style={{ minHeight: "100vh", padding: 24 }}>
      <Card withBorder padding="lg" radius="md" style={{ maxWidth: 480 }}>
        <Stack gap="md">
          <Title order={3}>已退出登录</Title>
          <Alert color="green">
            <Text size="sm">当前会话已结束。OAuth Gateway 已清除登录态。</Text>
          </Alert>
          <Group justify="flex-end">
            <Button
              onClick={() => {
                setCachedMe(null);
                void beginOAuthLogin("/", "OAuthLoggedOut.button");
              }}
            >
              重新登录
            </Button>
          </Group>
        </Stack>
      </Card>
    </Center>
  );
}
